import React from 'react'
import clsx from 'clsx'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost'
export type ButtonSize = 'xs' | 'sm' | 'md'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: ButtonSize
  loading?: boolean
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
}

const variantClassMap: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  ghost: 'hover:bg-gray-100 text-gray-700',
}

const sizeClassMap: Record<ButtonSize, string> = {
  xs: 'btn-xs',
  sm: 'px-3 py-1 text-sm',
  md: 'px-4 py-2',
}

export function Button({
  variant = 'secondary',
  size = 'sm',
  loading = false,
  startIcon,
  endIcon,
  className,
  children,
  disabled,
  ...rest
}: ButtonProps) {
  const isDisabled = disabled || loading
  return (
    <button
      className={clsx(
        'inline-flex items-center gap-2 rounded transition',
        variantClassMap[variant],
        sizeClassMap[size],
        isDisabled && 'opacity-70 cursor-not-allowed',
        className,
      )}
      disabled={isDisabled}
      {...rest}
    >
      {startIcon}
      {children}
      {loading ? (
        <span className="inline-block w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        endIcon
      )}
    </button>
  )
}

export default Button 